<template>
  <div>
    <NavMenu />

    <div class="page-content">

      <h1>Alight Motion Roadmap<button class="settings-toggle" v-bind:class="{enabled: showRoadmapSettings}" v-on:click="toggleRoadmapSettings"><span class="material-icons">settings</span></button></h1>
      <div v-if="!showRoadmapSettings" class="pm-attn quick-summary">
        <div><span>PM Attention:</span>
          <a v-bind:href="'https://alightcreative.myjetbrains.com/youtrack/issues/AM?q=' + encodeURIComponent(needsPMAttentionQuery + ' tag: -Effect')" target="_blank">{{needsPMAttentionSize}}</a>
          <div>
            <a v-bind:href="'https://alightcreative.myjetbrains.com/youtrack/issues/AM?q=' + encodeURIComponent(needsPMAttentionQuery + ' tag: -Effect type: Suggestion')" target="_blank">💡{{pmSuggestions}}</a>
            <a v-bind:href="'https://alightcreative.myjetbrains.com/youtrack/issues/AM?q=' + encodeURIComponent(needsPMAttentionQuery + ' tag: -Effect type: Bug')" target="_blank">🐛{{pmBugs}}</a>
            <a v-bind:href="'https://alightcreative.myjetbrains.com/youtrack/issues/AM?q=' + encodeURIComponent(needsPMAttentionQuery + ' tag: -Effect type: -Suggestion type: -Bug')" target="_blank">📝{{pmOther}}</a>
          </div>
          <div>
            <a v-bind:href="'https://alightcreative.myjetbrains.com/youtrack/issues/AM?q=' + encodeURIComponent(needsPMAttentionQuery + ' tag: Effect')" target="_blank">🌟{{pmEffects}}</a>
          </div>
        </div>
        <div><span>Backlog:</span> <a v-bind:href="'https://alightcreative.myjetbrains.com/youtrack/issues/AM?q=Target%20Version:%20Backlog'" target="_blank">{{backlogSize}}</a> </div>
      </div>

      <div v-if="busy"><BusySpinner /></div>

      <div v-if="message" class="warning-notice">{{message}}</div>

      <div v-if="!busy">

        <div v-if="showRoadmapSettings" class="filters">
          <div>
            <div>
              <b>Issue Display:</b><br/>
              <label><input type="checkbox" v-model="showAssignees"> Show Assignees</label><br />
              <label><input type="checkbox" v-model="showIssueNumbers"> Show Issue Numbers</label><br />
              <label><input type="checkbox" v-model="showSubtaskNumbers"> Show Subtask Numbers</label><br />
              <label><input type="checkbox" v-model="showState"> Show State</label><br />
  <!--            <label><input type="checkbox" v-model="showSubtasks"> Show Subtasks</label><br />-->
  <!--            <label><input type="checkbox" v-model="showSubtasksInline"> Show Subtasks Inline</label><br />-->
  <!--            <label><input type="checkbox" v-model="useSwimlanes"> Use Swimlanes</label>-->
            </div>
            <div class="highlightSelector"><b>Highlight Issues for:</b><br/><select v-model="highlightAssignee">
              <option>(None)</option>
              <option>Alice</option>
              <option>Douglas</option>
              <option>Evan</option>
              <option>Jeff</option>
              <option>JJ</option>
              <option>Matthew</option>
              <option>Soyoung</option>
              <option>TK</option>
            </select></div>
            <div style="margin-left: 8pt;">
            <label><input type="checkbox" v-model="hideNonHighlighted"> Hide Others</label><br />
            </div>
          </div>
          <div>

            <div>
            <b>Filter:</b><br/>
            <label><input type="checkbox" v-model="showResolved"> Show Resolved Issues</label><br />
            <label><input type="checkbox" v-model="showCompletedVersions"> Show Completed Versions</label><br />
            </div>

            <div>
            <b>PM Tools:</b><br/>
            <label v-bind:class="{hasParent: markSubtasksWithoutParents}"><input type="checkbox" v-model="markSubtasksWithoutParents"> Mark Subtasks Without Parents</label><br />
            <label v-bind:class="{unincludedSubtasks: markIssuesWithSubtaskInOtherTarget}"><input type="checkbox" v-model="markIssuesWithSubtaskInOtherTarget"> Mark Issues with Subtask not in Target Version</label><br />
            <label v-bind:class="{unassigned: markUnassignedIssues}"><input type="checkbox" v-model="markUnassignedIssues"> Mark Unassigned Issues</label><br />
            </div>

            <div class="pm-attn">
              <div><span>PM Attention:</span>
                <a v-bind:href="'https://alightcreative.myjetbrains.com/youtrack/issues/AM?q=' + encodeURIComponent(needsPMAttentionQuery + ' tag: -Effect')" target="_blank">{{needsPMAttentionSize}}</a>
                <div>
                  <a v-bind:href="'https://alightcreative.myjetbrains.com/youtrack/issues/AM?q=' + encodeURIComponent(needsPMAttentionQuery + ' tag: -Effect type: Suggestion')" target="_blank">💡{{pmSuggestions}}</a>
                  <a v-bind:href="'https://alightcreative.myjetbrains.com/youtrack/issues/AM?q=' + encodeURIComponent(needsPMAttentionQuery + ' tag: -Effect type: Bug')" target="_blank">🐛{{pmBugs}}</a>
                  <a v-bind:href="'https://alightcreative.myjetbrains.com/youtrack/issues/AM?q=' + encodeURIComponent(needsPMAttentionQuery + ' tag: -Effect type: -Suggestion type: -Bug')" target="_blank">📝{{pmOther}}</a>
                </div>
                <div>
                  <a v-bind:href="'https://alightcreative.myjetbrains.com/youtrack/issues/AM?q=' + encodeURIComponent(needsPMAttentionQuery + ' tag: Effect')" target="_blank">🌟{{pmEffects}}</a>
                </div>
              </div>
              <div><span>Backlog:</span> <a v-bind:href="'https://alightcreative.myjetbrains.com/youtrack/issues/AM?q=Target%20Version:%20Backlog'" target="_blank">{{backlogSize}}</a> </div>
            </div>

            <div v-if="encodedRoadmapSettings!==encodedRoadmapPrefs"><button v-on:click="saveRoadmapPrefs">Save as Default</button></div>

          </div>
        </div>

        <table class="roadmapTable" v-if="useSwimlanes">
          <tr class="header">
            <td class="cornerCell version-column-top">
              <div>
                <span class="cornerLabel">Versions</span>
                <span class="clickable material-icons" v-on:click="expandVersions()">unfold_more</span>
                <span class="clickable material-icons" v-on:click="collapseVersions()">unfold_less</span>
              </div>
              <div>
                <span class="cornerLabel">Lanes</span>
                <span class="clickable material-icons" v-on:click="expandLanes()">unfold_more</span>
                <span class="clickable material-icons" v-on:click="collapseLanes()">unfold_less</span>
              </div>
            </td>
            <td v-for="version in filteredSwimlanes[0].versions" :key="version.name" class="version-column-top" v-bind:class="{collapsedVer:collapsedVersions.includes(version.name)}">
              <div class="versionName">
<!--                <a v-bind:href="'https://alightcreative.myjetbrains.com/youtrack/issues/AM?q=Target%20Version:%20%7B' + version.name + '%7D'" target="_blank">{{version.name}}</a>-->
                <a v-on:click="toggleVersionExpanded(version.name)">{{version.name}}</a>
                <div class="versionProgressHolder">
                  <a v-bind:href="'https://alightcreative.myjetbrains.com/youtrack/issues/AM?q=Target%20Version:%20%7B' + encodeURIComponent(version.name) + '%7D'" target="_blank">
                    <ProgressRing v-bind:size="26" v-bind:progress="version.progress" v-bind:stroke-width="1.5" color="#9AB" base-color="#EEE" />
                  </a>
                </div>
              </div>
              <div class="versionLine" v-bind:style="{color: version.fg, backgroundColor: version.bg}"></div>
            </td>
          </tr>
          <tr class="header">
            <td class="cornerCell">
            </td>
            <td v-for="version in filteredSwimlanes[0].versions" :key="version.name" v-bind:class="{collapsedVer:collapsedVersions.includes(version.name)}">
              <div class="columnHead">
<!--                <div class="releaseBadge" v-if="version.released"><span class="material-icons">verified</span></div>-->
<!--                <div class="releaseCount" v-if="!version.released && version.bizdays>0">T-{{version.bizdays}}</div>-->

                <div v-for="tdate in version.targetDates" :key="tdate.label">
                  <div class="releaseBadge" v-if="version.released && tdate.displayLabel==='RELEASE DATE'"><span class="material-icons">verified</span></div>
                  <div class="releaseCount" v-if="!version.released && tdate.bizdays>0">T-{{tdate.bizdays}}</div>
                  <div class="infoItemLabel">{{tdate.displayLabel}}</div>
                  <div class="infoItem">{{tdate.displayDate}} <div class="infoPercent"><div class="value">{{tdate.completedPercent}}</div><div class="detail"><div v-for="sl in tdate.swimlanes" :key="sl">{{sl}}</div></div></div></div>
                </div>

<!--                <div class="infoItemLabel" v-if="version.released">RELEASE DATE</div>-->
<!--                <div class="infoItemLabel" v-if="!version.released">PRODUCTION TARGET</div>-->
<!--                <div class="infoItem">{{version.displayDate}}</div>-->

<!--                <div class="releaseCount" v-if="!version.released && version.testBizDays>0">T-{{version.testBizDays}}</div>-->
<!--                <div class="infoItemLabel" v-if="!version.released">FIRST RC BUILD</div>-->
<!--                <div class="infoItem" v-if="!version.released">{{version.testDisplayDate}}</div>-->
                <div class="infoItemLabel">SUMMARY</div>
                <div class="infoItem" v-html="version.description.replaceAll(/^ *--+$.*/gsm,'').replaceAll('\n','<br />')"></div>
                <div v-if="version.unassignedCount > 0" class="infoItemLabel">INFO</div>
                <div v-if="version.unassignedCount > 0" class="infoItem">Unassigned: <a v-bind:href="'https://alightcreative.myjetbrains.com/youtrack/issues/AM?q=Target%20Version:%20' + encodeURIComponent('{' + version.name + '} Assignee: Unassigned Type: -{Task Set} Type: -Epic #Unresolved ')" target="_blank">{{version.unassignedCount}}</a></div>

              </div>
            </td>
          </tr>
          <tr v-for="swimlane in filteredSwimlanes" :key="swimlane.name">
            <td class="expanded" v-if="!collapsedSwimlanes.includes(swimlane.name)" ><span class="expandicon nudgeRight" v-on:click="toggleSwimlaneExpanded(swimlane.name)"><span class="ifnotexpand"></span><span class="ifexpand"></span></span><span class="vtext">{{swimlane.name}}</span></td>
            <td class="htext" v-if="collapsedSwimlanes.includes(swimlane.name)"><span class="expandicon inline" v-on:click="toggleSwimlaneExpanded(swimlane.name)"><span class="ifnotexpand"></span><span class="ifexpand"></span></span><span>{{swimlane.name}}</span></td>
            <td v-for="version in swimlane.versions" :key="version.name" v-bind:class="{collapsedVer:collapsedVersions.includes(version.name)}" >
              <div v-if="collapsedSwimlanes.includes(swimlane.name)">
                <span class="swimlaneVersionSummary" v-bind:class="{matchingAssignee: version.issues.some(it=>it.shortAssignee===highlightAssignee||it.subtasks.some(it=>it.shortAssignee===highlightAssignee))}">{{version.issues.length}} Issues</span>
              </div>
              <div class="issueholder" v-if="!collapsedSwimlanes.includes(swimlane.name)">
                <div class="issue"
                     v-for="issue in version.issues"
                     :key="issue.id"
                     v-bind:class="{resolved: issue.resolved, unincludedSubtasks: markIssuesWithSubtaskInOtherTarget && issue.subtasks.length !== issue.subtaskCount, matchingSubUnassigned: markUnassignedIssues && issue.subtasks.some(subtask=>!subtask.shortAssignee && subtask.assigneeRequired) && !expandedIssues.includes(issue.id), matchingSubAssignee: issue.subtasks.some(subtask=>subtask.shortAssignee===highlightAssignee || subtask.highlightAssignee) && !expandedIssues.includes(issue.id), subtask: issue.isSubtask, unassigned: markUnassignedIssues && !issue.assignee && issue.assigneeRequired, hasParent: !!issue.parent && markSubtasksWithoutParents, matchingAssignee: highlightAssignee===issue.shortAssignee, expanded: expandedIssues.includes(issue.id) }">
                  <div class="assignee" v-if="showAssignees">{{issue.shortAssignee}}</div>
                  <span v-if="issue.subtasks.length>0 && showSubtasksInline" v-on:click="toggleExpanded(issue.id)" class="expandicon"><span class="ifnotexpand"></span><span class="ifexpand">︎</span></span>
                  <span v-if="issue.type==='Bug'" class="material-icons typeicon bug">bug_report</span>
<!--                  <span v-if="issue.type==='Feature' || issue.type==='Epic'" class="material-icons typeicon feature">architecture</span>-->
<!--                  <span v-if="issue.type==='Suggestion'" class="material-icons typeicon suggestion">emoji_objects</span>-->
                  <div class="issueId" v-if="showIssueNumbers"><a v-bind:href="'https://alightcreative.myjetbrains.com/youtrack/issue/'+issue.id" target="_blank">{{issue.id}}</a></div>
                  <div class="issueSummary"><a v-bind:href="'https://alightcreative.myjetbrains.com/youtrack/issue/'+issue.id" target="_blank">{{issue.summary}}</a></div>
                  <div class="issueState" v-if="showState" v-bind:class="'state-'+issue.state.replaceAll(' ','-')"><span>{{issue.state}}</span></div>
                  <div v-if="showSubtasksInline" class="ifexpand">
                    <div v-for="subtask in issue.subtasks" :key="subtask.id">
                      <RoadmapSubtask :highlight-assignee="highlightAssignee"
                                    :mark-unassigned-issues="markUnassignedIssues" :show-assignees="showAssignees"
                                    :show-state="showState" :show-subtask-numbers="showSubtaskNumbers"
                                    :subtask="subtask"/>
                    </div>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </table>

        <div class="roadmap" v-if="!useSwimlanes">
          <div class="version" v-for="version in filteredVersions" :key="version.name">
            <div class="versionName"><a v-bind:href="'https://alightcreative.myjetbrains.com/youtrack/issues/AM?q=Target%20Version:%20%7B' + version.name + '%7D'" target="_blank">{{version.name}}</a></div>
            <div class="versionLine" v-bind:style="{color: version.fg, backgroundColor: version.bg}"></div>
            <div class="columnHead">
              <div class="releaseBadge" v-if="version.released"><span class="material-icons">verified</span></div>
              <div class="releaseCount" v-if="!version.released && version.bizdays>0">T-{{version.bizdays}}</div>
              <div class="infoItemLabel" v-if="version.released">RELEASE DATE</div>
              <div class="infoItemLabel" v-if="!version.released">TARGET DATE</div>
              <div class="infoItem">{{version.displayDate}}</div>
              <div class="infoItemLabel">SUMMARY</div>
              <div class="infoItem">{{version.description}}</div>
            </div>
            <div v-for="subsystem in version.issueSubsystems" :key="subsystem.name">
              <div class="issueSubsystemSectionHead"><span v-if="subsystem.name">{{subsystem.name}}</span><span v-if="!subsystem.name">(No Subsystem)</span></div>
              <div v-for="issueType in subsystem.issueTypes" :key="issueType.name">
                <div class="issueTypeSectionHead">{{issueType.name}}</div>
                <div class="issue" v-for="issue in issueType.issues" :key="issue.id" v-bind:class="{resolved: issue.resolved, subtask: issue.isSubtask, hasParent: !!issue.parent}">
                  <div class="issueId" v-if="showIssueNumbers"><a v-bind:href="'https://alightcreative.myjetbrains.com/youtrack/issue/'+issue.id" target="_blank">{{issue.id}}</a></div>
                  <div class="issueSummary">{{issue.summary}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

    </div>

  </div>
</template>

<script>

import NavMenu from '@/components/NavMenu.vue'
import BusySpinner from '@/components/BusySpinner.vue'
import ProgressRing from '@/components/ProgressRing.vue'
import axios from 'axios'
import firebase from "firebase";
import 'firebase/auth'
import RoadmapSubtask from "@/views/RoadmapSubtask";

var auth = firebase.auth();

let dateFormat = Intl.DateTimeFormat(undefined,{
  year: "numeric",
  month: "short",
  day: "2-digit",
  timeZone: 'Asia/Seoul'
})

function parseAMDateString(s) {
  let parts = s.split("-")
  return new Date(parts[0], parts[1]-1, parts[2]);
}

export default {
  name: 'Roadmap',
  components: {RoadmapSubtask, NavMenu, BusySpinner, ProgressRing },
  data: ()=>({
    busy: false,
    message: "",
    useSwimlanes: true,
    showRoadmapSettings: false,
    swimlanes: [],
    collapsedSwimlanes: ["Bug Fixes", "Other", "Release Preparation", "Release Follow-up"],
    collapsedVersions: [],
    versions: [],
    showSubtasks: false,
    showSubtasksInline: true,
    expandedIssues: [],
    needsPMAttentionSize : 0,
    pmBugs : 0,
    pmSuggestions : 0,
    pmEffects : 0,
    pmOther : 0,
    needsPMAttentionQuery : "",
    backlogSize : 0
  }),
  methods: {
    async saveRoadmapPrefs() {
      let idToken = await auth.currentUser.getIdToken(true);
      let apiURL;
      if( window.location.hostname === "alight-creative-staging.firebaseapp.com" ||
          window.location.hostname === "alight-creative-staging.web.app" ||
          window.location.hostname === "localhost" ) {
        apiURL = "http://0.0.0.0:8080/"
      } else {
        apiURL = "https://alight-creative-corporate.du.r.appspot.com/"
      }
      await axios.get(apiURL + `siteprefs/roadmapView/set?value=${encodeURIComponent(this.encodedRoadmapSettings)}`,
          {headers: {"Authorization":`Bearer ${idToken}`}})
      this.$store.commit("updateRoadmapPrefs", this.$route.query)
    },
    toggleRoadmapSettings() {
      this.showRoadmapSettings = !this.showRoadmapSettings;
    },
    collapseLanes() {
      this.collapsedSwimlanes = ["User Interface", "IAP & Ads", "Engine & Renderer", "Effects", "Bug Fixes", "Other", "Release Preparation", "Release Follow-up"]
    },
    collapseVersions() {
      this.collapsedVersions = this.versions.map(it=>it.name);
    },
    expandLanes() {
      this.collapsedSwimlanes = []
    },
    expandVersions() {
      this.collapsedVersions = []
    },
    toggleExpanded(issueId) {
      if( this.expandedIssues.includes(issueId) ) {
        this.expandedIssues = this.expandedIssues.filter(it=>it!==issueId)
      } else {
        this.expandedIssues.push(issueId)
      }
    },
    toggleVersionExpanded(versionId) {
      if( this.collapsedVersions.includes(versionId)) {
        this.collapsedVersions = this.collapsedVersions.filter(it=>it!==versionId);
      } else {
        this.collapsedVersions.push(versionId);
      }
    },
    toggleSwimlaneExpanded(swimlaneId) {
      if( this.collapsedSwimlanes.includes(swimlaneId) ) {
        this.collapsedSwimlanes = this.collapsedSwimlanes.filter(it=>it!==swimlaneId)
      } else {
        this.collapsedSwimlanes.push(swimlaneId)
      }
    }
  },
  computed: {
    roadmapPrefs() {return this.$store.state.roadmapPrefs},
    encodedRoadmapPrefs() {return this.$store.state.roadmapPrefs ? JSON.stringify(this.$store.state.roadmapPrefs) : ""},
    encodedRoadmapSettings() { return this.$route.query ? JSON.stringify(this.$route.query) : "" },
    showAssignees: {
      get() {return !(this.$route.query.sa === "n")},
      set(value) { this.$router.replace({query: {...this.$route.query, sa: (!value) ? "n" : undefined}}) }
    },
    showIssueNumbers: {
      get() {return !(this.$route.query.si === "n")},
      set(value) { this.$router.replace({query: {...this.$route.query, si: (!value) ? "n" : undefined}}) }
    },
    showResolved: {
      get() {return !(this.$route.query.resolved === "hide")},
      set(value) { this.$router.replace({query: {...this.$route.query, resolved: (!value) ? "hide" : undefined}}) }
    },
    showCompletedVersions: {
      get() {return (this.$route.query.complete === "show")},
      set(value) { this.$router.replace({query: {...this.$route.query, complete: (value) ? "show" : undefined}}) }
    },


    showSubtaskNumbers: {
      get() {return this.$route.query.stn === "y"},
      set(value) { this.$router.replace({query: {...this.$route.query, stn: value ? "y" : undefined}}) }
    },
    hideNonHighlighted: {
      get() {return this.$route.query.others === "hide"},
      set(value) { this.$router.replace({query: {...this.$route.query, others: value ? "hide" : undefined}}) }
    },
    showState: {
      get() {return this.$route.query.state === "show"},
      set(value) { this.$router.replace({query: {...this.$route.query, state: value ? "show" : undefined}}) }
    },
    highlightAssignee: {
      get() {return this.$route.query.h ?? "(None)"},
      set(value) { this.$router.replace({query: {...this.$route.query, h: ((value ?? "(None)") === "(None)") ? undefined : value}}) }
    },
    markSubtasksWithoutParents: {
      get() {return this.$route.query.subtask_without_parents === "mark"},
      set(value) { this.$router.replace({query: {...this.$route.query, subtask_without_parents: value ? "mark" : undefined}}) }
    },
    markIssuesWithSubtaskInOtherTarget: {
      get() {return this.$route.query.subtask_not_in_target === "mark"},
      set(value) { this.$router.replace({query: {...this.$route.query, subtask_not_in_target: value ? "mark" : undefined}}) }
    },
    markUnassignedIssues: {
      get() {return this.$route.query.unassigned_issues === "mark"},
      set(value) { this.$router.replace({query: {...this.$route.query, unassigned_issues: value ? "mark" : undefined}}) }
    },

    filteredSwimlanes() {

      let swimlanes = ["User Interface", "IAP & Ads", "Engine & Renderer", "Effects", "Bug Fixes", "Other", "Release Preparation", "Release Follow-up"]
      let issueTypes = ["Epic","Feature","Suggestion","User Issue","Bug","Task"]

      function swimlanesForLabel(label) {
        let l = label.trim().toLowerCase()
        switch(l) {
          case "dev": return ["User Interface","Engine & Renderer"]
          case "beta": return ["Effects","IAP & Ads","Other"]
          case "rc": return ["Bug Fixes"]
          case "release": return ["Release Preparation"]
          case "follow-up": return ["Release Follow-up"]
          default: return []
        }
      }

      function displayLabelForTargetDateLabel(label,released) {
        let l = label.trim().toLowerCase()
        switch(l) {
          case "dev": return released ? "DEV RELEASED" : "DEV TARGET"
          case "beta": return released ? "BETA RELEASED" : "BETA TARGET"
          case "rc": return released ? "FIRST RC RELEASED" : "FIRST RC TARGET"
          case "release": return released ? "RELEASE DATE" : "PRODUCTION TARGET"
          case "follow-up": return "POST-RELEASE TASK DEADLINE"
          default: return label.replace("•","").trim().toUpperCase() + (released ? " DATE" : " TARGET")
        }
      }

      function swimlaneForIssue(issue) {

        function handleSubsystemPriorty(issue) {
          if( issue.type === "Bug" ) {
            if( issue.priority === "Critical" || issue.priority === "Show-stopper" || issue.priority === "Major" ) {
              return issue.subsystem
            } else {
              return "Bug Fixes"
            }
          } else {
            if( issue.priority === "Minor" ) {
              return "Other"
            } else {
              return issue.subsystem
            }
          }
        }

        if( issue.subsystem === "User Interface" )                                                return handleSubsystemPriorty(issue)
        if( issue.subsystem === "IAP & Ads" )                                                     return handleSubsystemPriorty(issue)
        if( issue.subsystem === "Engine & Renderer" )                                             return handleSubsystemPriorty(issue)
        if( issue.subsystem === "Effects" )                                                       return "Effects"
        if( issue.subsystem === "Release Preparation" )                                           return "Release Preparation"
        if( issue.subsystem === "Release Follow-up" )                                             return "Release Follow-up"
        if( issue.type  === "Suggestion" || issue.type==="Feature" || issue.type==="Epic" )       return "Other"
        if( issue.type  === "Bug" || issue.type  === "User Issue")                                return "Bug Fixes"
        return "Other"
      }

      let allIssues = []

      for( let ver of this.versions ) {
        for( let issue of ver.issues ) {
          allIssues.push(issue)
          let swimlane = swimlaneForIssue(issue)
          if( !swimlanes.includes(swimlane) )
            swimlanes.push(swimlane)
          if( !issueTypes.includes(issue.type) )
            issueTypes.push(issue.type)
        }
      }
      let allIssueIds = allIssues.map(issue=>issue.id)
      let now = new Date()

      let testDays = 7

      function getSubtasks(ctx,issue) {
        return (
            allIssues
                .filter(i=>i.parent===issue.id)
                .map(subtask=>({...subtask,
                  shortAssignee: subtask.assignee.includes(' ') ? subtask.assignee.substr(0,subtask.assignee.indexOf(' ')) : subtask.assignee,
                  assigneeRequired: subtask.type !== "Task Set" && subtask.type !== "Epic",
                  subtasks: getSubtasks(ctx,subtask),
                }))
                .map(subtask=>({...subtask, highlightAssignee: subtask.shortAssignee===ctx.highlightAssignee || subtask.subtasks.some(it=>it.highlightAssignee) }))
                .filter(subtask=>subtask.highlightAssignee || !ctx.hideNonHighlighted || ctx.highlightAssignee==="(None)")
                .filter(subtask=>ctx.showResolved || !subtask.resolved)
        )
      }

      return [...swimlanes].map(swimlane=>({
        name: swimlane,
        versions: [...this.versions].filter(v=>!v.released || this.showCompletedVersions).map(v=>({...v,
          name: v.name,
          targetDates: [
              ...(v.description
                  .split(/\r\n|\r|\n/)
                  .filter(it=>it.includes(":"))
                  .map(it=>it.split(/:(.+)/).map(part=>part.trim()))
                  .filter(it=>it[0].length > 0 && /^[0-9]{4}-[0-9]{1,2}-[0-9]{1,2}$/.test(it[1]))   // Filter out things that aren't dates
                  .map(it=>({
                    label: it[0],
                    date: parseAMDateString(it[1])
                  }))
                  .map(it=>({
                    label: it.label,
                    date: it.date,
                    displayDate: it.date ? dateFormat.format(it.date) : "Not Scheduled",
                    bizdays: bizDays(now,it.date),
                    issues: v.issues.filter(issue=>swimlanesForLabel(it.label).includes(swimlaneForIssue(issue))),
                    swimlanes: swimlanesForLabel(it.label)
                  }))),
            {
              label: "Release",
              date: new Date(v.releaseDate),
              displayDate: v.releaseDate ? dateFormat.format(new Date(v.releaseDate)) : "Not Scheduled",
              bizdays: bizDays(now,new Date(v.releaseDate)),
              issues: v.issues.filter(issue=>swimlanesForLabel("release").includes(swimlaneForIssue(issue))),
              swimlanes: swimlanesForLabel("Release")
            }
          ].map(td=>({
            ...td,
            displayLabel: displayLabelForTargetDateLabel(td.label, v.released),
            totalIssues: td.issues.length,
            resolvedIssues: td.issues.filter(it=>it.resolved).length,
            completedPercent: td.issues.length <= 0 ? "" : "(" + Math.round((td.issues.filter(it=>it.resolved).length / td.issues.length) * 100) + "%)"
          })).sort((a,b)=> b.date.getTime() - a.date.getTime()),
          bizdays: bizDays(now,new Date(v.releaseDate)),
          testDate: v.releaseDate ? addBizDays(new Date(v.releaseDate),-testDays) : null,
          displayDate:  v.releaseDate ? dateFormat.format(new Date(v.releaseDate)) : "Not Scheduled",
          testDisplayDate: v.releaseDate ? dateFormat.format(addBizDays(new Date(v.releaseDate),-testDays)) : "Not Scheduled",
          testBizDays: bizDays(now,addBizDays(new Date(v.releaseDate),-testDays)),
          allIssues: v.issues,
          issues: v.issues
              .filter(issue=>swimlaneForIssue(issue)===swimlane)
              .map(issue=>({...issue,
                isSubtask: !(issue.parent==null || !allIssueIds.includes(issue.parent)),
                assigneeRequired: issue.type !== "Task Set" && issue.type !== "Epic"
              }))
              .filter(issue=> this.showSubtasks || !issue.isSubtask)
              .filter(issue=> this.showResolved || !issue.resolved)
              .map(issue=>({...issue,
                shortAssignee: issue.assignee.includes(' ') ? issue.assignee.substr(0,issue.assignee.indexOf(' ')) : issue.assignee,
                subtasks: getSubtasks(this,issue)
              })).filter(issue=>issue.shortAssignee===this.highlightAssignee || !this.hideNonHighlighted || this.highlightAssignee==="(None)" || issue.subtasks.length>0),
          issueTypes: issueTypes.map(issueType=>({
            name: issueType,
            issues: v.issues
                .filter(issue=>issue.type===issueType && swimlaneForIssue(issue)===swimlane)
                .map(issue=>({...issue,
                  isSubtask: !(issue.parent==null || !allIssueIds.includes(issue.parent)),
                  assigneeRequired: issue.type !== "Task Set" && issue.type !== "Epic"
                }))
                .filter(issue=> this.showSubtasks || !issue.isSubtask)
                .filter(issue=> this.showResolved || !issue.resolved)
          })).filter(issueType=>issueType.issues.length > 0)
        })).map(v=>({...v,
          progress: v.allIssues.reduce((n,issue)=>n + (!!issue.resolved), 0) / v.allIssues.length,
          unassignedCount: v.allIssues.reduce((n,issue)=>n + (!!(!issue.resolved && issue.type !== "Task Set" && issue.type !== "Epic" && !issue.assignee)), 0)
        }))
      })).filter(it=>it.versions.some(v=>v.issues.length>0))

    },
    filteredVersions() {

      let issueTypes = ["Epic","Feature","Suggestion","User Issue","Bug","Task"]
      let subsystems = ["User Interface","IAP & Ads", "Engine & Renderer", "Effects"]
      let allIssues = []
      for( let ver of this.versions ) {
        for( let issue of ver.issues ) {
          allIssues.push(issue)
          if( !issueTypes.includes(issue.type) )
            issueTypes.push(issue.type)
          if( !subsystems.includes(issue.subsystem))
            subsystems.push(issue.subsystem)
        }
      }
      let allIssueIds = allIssues.map(issue=>issue.id)

      let now = new Date()

      return [...this.versions].map(v=>({...v,
        issueSubsystems: subsystems.map(subsystem=>({
          name: subsystem,
          issues: v.issues
              .filter(issue=>issue.subsystem===subsystem)
              .map(issue=>({...issue,
                isSubtask: !(issue.parent==null || !allIssueIds.includes(issue.parent)),
                assigneeRequired: issue.type !== "Task Set" && issue.type !== "Epic"
              }))
              .filter(issue=> this.showSubtasks || !issue.isSubtask)
              .filter(issue=> this.showResolved || !issue.resolved),
          issueTypes: issueTypes.map(issueType=>({
            name: issueType,
            issues: v.issues
                .filter(issue=>issue.type===issueType && issue.subsystem===subsystem)
                .map(issue=>({...issue,
                  isSubtask: !(issue.parent==null || !allIssueIds.includes(issue.parent)),
                  assigneeRequired: issue.type !== "Task Set" && issue.type !== "Epic"
                }))
                .filter(issue=> this.showSubtasks || !issue.isSubtask)
                .filter(issue=> this.showResolved || !issue.resolved)
          })).filter(issueType=>issueType.issues.length > 0)
        })).filter(subsystem=>subsystem.issueTypes.length > 0),
        issueTypes: issueTypes.map(issueType=>({
          name: issueType,
          issues: v.issues
              .filter(issue=>issue.type===issueType)
              .map(issue=>({...issue,
                isSubtask: !(issue.parent==null || !allIssueIds.includes(issue.parent)),
                assigneeRequired: issue.type !== "Task Set" && issue.type !== "Epic"
              }))
              .filter(issue=> this.showSubtasks || !issue.isSubtask)
              .filter(issue=> this.showResolved || !issue.resolved)
        })).filter(issueType=>issueType.issues.length > 0),
        bizdays: bizDays(now,new Date(v.releaseDate)),
        displayDate: v.releaseDate ? dateFormat.format(new Date(v.releaseDate)) : "None"}))
    }
  },
  async mounted() {
    this.busy = true
    this.message = ""
    try {
      let idToken = await auth.currentUser.getIdToken(true);
      let apiURL;
      if( window.location.hostname === "alight-creative-staging.firebaseapp.com" ||
          window.location.hostname === "alight-creative-staging.web.app" ||
          window.location.hostname === "localhost" ) {
        apiURL = "http://0.0.0.0:8080/am/"
      } else {
        apiURL = "https://alight-creative-corporate.du.r.appspot.com/am/"
      }
      // let t = await axios.get(testurl + "targetVersions",
      //     {headers: {"Authorization":`Bearer ${idToken}`}})
      // console.log(t.data)
      let t2 = await axios.get(apiURL + "roadmap",
          {headers: {"Authorization":`Bearer ${idToken}`}})
      console.log(t2.data)
      this.message = ``
      this.versions = t2.data.versions
      this.needsPMAttentionQuery = t2.data.needsPMAttentionQuery
      this.needsPMAttentionSize  = t2.data.needsPMAttention
      this.pmBugs = t2.data.needsPMAttentionBugs
      this.pmSuggestions = t2.data.needsPMAttentionSuggestions
      this.pmEffects = t2.data.needsPMAttentionEffects
      this.pmOther = t2.data.needsPMAttentionOther
      this.backlogSize  = t2.data.backlogSize
      this.busy = false
    } catch(e) {
      this.busy = false
      this.message = `Failed: ${e}`
    }
  }
}

/**
 * @param {Date} date
 * @returns {Date}
 */
function nextDay(date) {
  let d = new Date(date)
  d.setDate(d.getDate()+1)
  return d
}

/**
 * @param {Date} date
 * @returns {Date}
 */
function prevDay(date) {
  let d = new Date(date)
  d.setDate(d.getDate()-1)
  return d
}

let KOREAN_HOLIDAYS = [
    "2020-12-25",
    "2021-01-01",
    "2021-02-11",
    "2021-02-12",
    "2021-02-13",
    "2021-03-01",
    "2021-05-05",
    "2021-05-19",
    "2021-09-20",
    "2021-09-21",
    "2021-09-22",
    "2021-12-25",
    "2022-01-31",
    "2022-02-01",
    "2022-02-02",
    "2022-03-01",
    "2022-05-05",
    "2022-06-01",
    "2022-06-06",
    "2022-08-15",
    "2022-09-09",
    "2022-09-10",
    "2022-09-11",
    "2022-10-03",
    "2023-01-21",
    "2023-01-22",
    "2023-03-01",
    "2023-05-05",
    "2023-06-06",
    "2023-08-15",
    "2023-09-28",
    "2023-09-29",
    "2023-09-30",
    "2023-10-03",
    "2023-10-09",
    "2023-12-25"
]

/**
 * @param {Date} a
 * @param {Date} b
 * @returns {number}
 */
function bizDays( a, b) {
  let d = a;
  let result = 0
  while(d.getTime() < b.getTime()) {
    d = nextDay(d)
    let dateStr = (d.getFullYear() + "-" + (""+(d.getMonth()+1)).padStart(2,"0") + "-" + (""+(d.getDate())).padStart(2,"0"))
    let dayOfWeek = d.getDay()
    if( dayOfWeek > 0 && dayOfWeek < 6 && !KOREAN_HOLIDAYS.includes(dateStr) )
      result++
  }
  return result
}

function isValidDate(d) {
  return d instanceof Date && !isNaN(d);
}

/**
 * @param {Date} baseDate
 * @param {Date} dayCount
 * @returns {Date}
 */
function addBizDays( baseDate, dayCount) {
  if( dayCount === 0 || !isValidDate(baseDate) ) return baseDate
  // console.log(`addBizDays(${baseDate},${dayCount})`)
  if( dayCount < 0 ) {
    let remaining = -dayCount;
    let d = baseDate
    while( remaining > 0 ) {
      d = prevDay(d)
      let dateStr = (d.getFullYear() + "-" + (""+(d.getMonth()+1)).padStart(2,"0") + "-" + (""+(d.getDate())).padStart(2,"0"))
      let dayOfWeek = d.getDay()
      // console.log(`addBizDays: remaining=${remaining} dayOfWeek=${dayOfWeek} dateStr=${dateStr} d=${d}`)
      if( dayOfWeek > 0 && dayOfWeek < 6 && !KOREAN_HOLIDAYS.includes(dateStr) )
        remaining--
    }
    return d;

  } else {
    let remaining = dayCount;
    let d = baseDate
    while( remaining > 0 ) {
      d = nextDay(d)
      let dateStr = (d.getFullYear() + "-" + (""+(d.getMonth()+1)).padStart(2,"0") + "-" + (""+(d.getDate())).padStart(2,"0"))
      let dayOfWeek = d.getDay()
      // console.log(`addBizDays: remaining=${remaining} dayOfWeek=${dayOfWeek} dateStr=${dateStr} d=${d}`)
      if( dayOfWeek > 0 && dayOfWeek < 6 && !KOREAN_HOLIDAYS.includes(dateStr) )
        remaining--
    }
    return d;
  }
}

</script>

<style lang="scss" scoped>

.warning-notice {
  background: #ffe5a0;
  border-radius: 5pt;
  color: #d61414;
  padding: 5pt;
}

.filters {
  font-size: 10pt;
  margin-left: 10pt;
  margin-top: 5pt;
  margin-bottom: 20pt;
  display: flex;
  border: 1px solid #DDD;
  width: 400pt;
  padding: 8pt;
  border-radius: 5pt;

  label {
    white-space: nowrap;
  }
  > div {
    margin-left: 10pt;
    margin-right: 10pt;

    > div:not(:first-child) {
      margin-top: 8pt;
      select { margin-left: 2pt; margin-top: 2pt;}
    }
  }

  & .unassigned {
    background: #e5b7ea;
  }
  & .unincludedSubtasks {
    background: #ffcca7;
  }
  & .hasParent {
    background: #f5c7c7;
  }


}

.ifexpand {
  display: none;
}
.ifnotexpand{
  display: block;
}

button.settings-toggle {
  cursor: pointer;
  background: none;
  border-radius: 3pt;
  padding: 3pt 3pt 1pt;
  margin-left: 3pt;
  color: #6c91b7;
  outline: none;
  border: 1px solid #fff;
  &:hover {
    background: #f1f5f6;
  }
  &:active {
    color: #2c3e50;
  }
  &.enabled {
    border: 1px solid #d0dde3;
  }
  span.material-icons {
    font-size: 12pt;
  }
}

.expandicon {
  cursor: pointer;
  > .ifexpand {
    width: 0;
    height: 0;
    border-left: 6px solid transparent;
    border-top: 6px solid #888;
    border-right: 6px solid transparent;
    border-bottom: 6px solid transparent;
    margin: 2px;
    position: relative;
    top: 2px;
    left: -1px;
  }
  > .ifnotexpand {
    width: 0;
    height: 0;
    border-left: 6px solid #888;
    border-top: 6px solid transparent;
    border-right: 6px solid transparent;
    border-bottom: 6px solid transparent;
    margin: 2px;
    position: relative;
    top: -1px;
  }

  &:hover {
    > .ifexpand {
      border-top: 6px solid black;
    }
    > .ifnotexpand {
      border-left: 6px solid black;
    }
  }
}

.expanded {
  .ifexpand {
    display: block;
  }
  .ifnotexpand {
    display: none;
  }
}

table.roadmapTable {
  border-collapse: collapse;
  table-layout: fixed;
  tr.header {

    .version-column-top {
      position: sticky;
      top: -14px;
      background: #FFF;
      z-index: 10;
      box-shadow: 0 4px 4px 0 #FFF;
    }

    .clickable {
      cursor: pointer;
      color: #2c3e50;
      &:hover {
        color: #3e5d7c;
      }
      &:active {
        color: #6c91b7;
      }
    }

    .versionName {
      padding-left: 1pt;
      padding-right: 1pt;
      border-bottom: 2pt solid #CCC;
      width: 165pt;
      overflow: hidden;
      white-space: nowrap;

      a {
        display: inline-block;
        width: 145pt;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        text-decoration: none;
        color: #2c3e50;
        cursor: pointer;
      }
    }

    .versionLine {
      position: relative;
      top: -2pt;
      height: 2pt;
      opacity: 0.5;
    }

    .releaseBadge {
      float: right;
      color: #c0ddd3;
    }
    .releaseCount {
      position: relative;
      top: -3pt;
      float: right;
      color: #bcbcbc;
      font-weight: bold;
      font-size: 20pt;
    }
    .infoItem {
      font-size: 10pt;
      margin-left: 3pt;
      margin-bottom: 10pt;
      .infoPercent {
        cursor: help;
        color: #5e7a92;
        display: inline-block;
        .value {
          display: inline-block;
        }
        .detail {
          display: none;
          position: absolute;
          min-width: 150pt;
          background: #EEE;
          color: black;
          z-index: 20;
          div {
            margin: 4pt;
          }
        }
      }

      &:hover .infoPercent {
        .value {
          background: #EEE;
        }
        .detail {
          display: block;
        }
      }
    }

    .infoItemLabel {
      margin-top: 5pt;
      font-size: 6pt;
      font-weight: bold;
      margin-left: 3pt;
      color: #888;
    }
  }
  td:first-child {
    min-width: 70pt;
    margin-top: 2pt;
    margin-bottom: 2pt;
    vertical-align: center;
    font-weight: bold;
    font-size: 8pt;
    .nudgeRight {
      position: relative;
      left: 0.5pt;
    }
    .inline {
      display: inline-block;
      position: relative;
      top: 3.5pt;
    }
    .vtext {
      position: relative;
      font-size: 10pt;
      margin-top: auto;
      margin-bottom: auto;
      padding-top: 2pt;
      padding-bottom: 2pt;
      color: #333;
      writing-mode: vertical-rl;
      white-space: nowrap;
      display:inline-block;
    }
    &.htext {
      max-width: 70pt;
      white-space: nowrap;
      overflow-x: hidden;
      text-overflow: ellipsis;
    }
  }
  td.cornerCell {
    vertical-align: bottom;
    div { margin-bottom: 2pt;}
    .cornerLabel {
      font-weight: lighter;
      color: #9fa3aa;
    }
    .material-icons {
      font-size: 10pt;
      position: relative;
      top: 2pt;
    }
  }
  td {
    padding-top: 3pt;
    padding-bottom: 8pt;
    padding-left: 6pt;
    padding-right: 6pt;
    vertical-align: top;
    max-width: 165pt;

    .swimlaneVersionSummary {
      font-size: 10pt;
      padding: 2pt;
      border-radius: 2pt;
      &.matchingAssignee {
        border: 1px solid #000000;
        background: #ffe3a3;
      }
    }

    .issueholder {
      //max-height: 400pt;
      //overflow-y: scroll;
    }

    .issue {
      background: #EEE;
      border-radius: 2pt;
      font-size: 8pt;
      margin-top: 3pt;
      padding: 2pt;
      border: 1px solid #EEE;

      .issueSummary {
        a {
          text-decoration: none;
          color: inherit;
        }
      }

      &.matchingAssignee {
        border: 1px solid #000000;
        background: #ffe3a3;
      }

      &.unassigned {
        background: #e5b7ea;
      }
      &.unincludedSubtasks {
        background: #ffcca7;
      }

      &.matchingSubAssignee {
        border: 1px solid #000000;
        background: #f3e8ce;
      }

      &.matchingSubUnassigned {
        background: #e8dce9;
      }

      &.resolved {
        text-decoration: line-through;
        opacity: .25;
      }

      &.hasParent {
        border: 1px solid #f5c7c7;
        background: #f5c7c7;
      }

      &.subtask {
        background: #caeae9;
      }

      &.hasParent.matchingAssignee {
        border: 1px solid #000000;
        background: #ffc859;
      }

      .issueId {
        font-weight: bold;
        a {
          text-decoration: none;
          color: #4468c4;
        }
        a:visited {
          color: #8f49c1;
        }
        a:hover {
          text-decoration: underline;
        }
      }

      .assignee {
        color: #AAA;
        float: right;
        text-align: right;
        margin-right: 2pt;
      }

      .issueState {
        position: relative;
        right: -3pt;
        bottom: -2pt;
        color: #706c79;
        text-align: right;

        span {
          display: inline-block;
          padding-right: 2pt;
          padding-left: 2pt;
          border-radius: 2pt;
        }

        &.state-Open > span {
          background: #e3e3e3;
        }
        &.state-Selected-for-Development > span {
          background: #d2e5c8;
        }
        &.state-In-Progress > span {
          background: #9cd47e;
        }
        &.state-Done > span {
          background: #81b06a;
        }
        &.state-Done > span {
          background: #81b06a;
        }
        &.state-Verified > span {
          background: #81b06a;
        }

      }

      .typeicon {
        float: left;
        font-size: 10pt;
        &.bug { color: #de7e64; }
        &.feature { color: #74b392; }
        &.suggestion { color: #a8cbcb; }
      }

      .expandicon {
        float: left;
        font-size: 8pt;
        width: 12pt;
        cursor: pointer;
        color: #AAA;

        &:hover {
          color: #786788;
        }
      }
    }
  }
  tr {
    &:nth-child(n+2) {
      border-bottom: 2px solid #dbe2ea;
    }
  }
  tr:first-child td {
    padding-top: 20pt;
  }
  .collapsedVer, tr.header .collapsedVer {
    .versionName {
      width: 14pt;
      height: 20pt;
      overflow: visible;
      position: relative;
      border: none;
      .versionProgressHolder {
        display: none;
      }
      a {
        writing-mode: vertical-rl;
        background: #FFF;
        display: block;
        position: absolute;
        left: -2pt;
        overflow: visible;
        //height: 100pt;
        width: 27pt;
        line-height: 28pt;
      }
    }
    .versionLine {
      position: absolute;
      overflow: visible;
      left: 2pt;
      top: 18pt;
      width: 2pt;
      height: 100pt;
      opacity: 0.5;
    }
    .infoItem, .infoItemLabel, .swimlaneVersionSummary, .columnHead, .issue, .issueholder {
      display: none;
    }
  }
  //tr:nth-child(even) {
  //  background: #f6fafa;
  //}
}

.versionProgressHolder {
  position: relative;
  top: 1pt;
  display: inline-block;
}

.roadmap {
  display: flex;
  overflow-x: auto;

  .version {
    overflow: hidden;
    flex-shrink: 0;
    width: 210px;
    margin-left: 5pt;
    margin-right: 1pt;
    border-right: 1px solid #EEE;
    padding-right: 5pt;

    .columnHead {
      min-height: 60pt;

      .releaseBadge {
        float: right;
        color: #c0ddd3;
      }

      .releaseCount {
        position: relative;
        top: -3pt;
        float: right;
        color: #bcbcbc;
        font-weight: bold;
        font-size: 20pt;
      }
    }

    .infoItem {
      font-size: 10pt;
      margin-left: 3pt;
      margin-bottom: 10pt;
    }

    .infoItemLabel {
      margin-top: 5pt;
      font-size: 6pt;
      font-weight: bold;
      margin-left: 3pt;
      color: #888;
    }

    .versionName {
      //border-radius: 100pt;
      padding-left: 1pt;
      padding-right: 1pt;
      border-bottom: 2pt solid #CCC;
      //border: 1px solid #eaeaea;
      a {
        text-decoration: none;
        color: #2c3e50;
      }

    }

    .versionLine {
      position: relative;
      top: -1pt;
      height: 1pt;
      opacity: 0.5;
    }

    .issueTypeSectionHead {
      margin-top: 12pt;
      font-size: 10pt;
      font-weight: lighter;
    }

    .issueSubsystemSectionHead {
      margin-top: 12pt;
      font-size: 10pt;
      font-weight: lighter;
      background: #b8e9d8;
    }

    .issue {
      background: #EEE;
      border-radius: 2pt;
      font-size: 8pt;
      margin-top: 3pt;

      &.resolved {
        text-decoration: line-through;
        opacity: 0.25;
      }

      &.hasParent {
        background: #f5c7c7;
      }

      &.subtask {
        background: #caeae9;
      }

      .issueId {
        font-weight: bold;
      }
    }

    //.issue {
    //  margin-left: 3pt;
    //  font-size: 8pt;
    //  margin-top: 2pt;
    //  white-space: nowrap;
    //  text-overflow: ellipsis;
    //  overflow: hidden;
    //}

  }
}

h1 {
  font-size: 16pt;
  margin-left: 10pt;
}

.pm-attn {
  & > div {
    & > div {
      display: inline-block;
      background: #f5f7f8;
      border-radius: 3pt;
      padding-bottom: 2pt;
      margin-top: 1pt;
      margin-right: 1.5pt;
    }
  }
  a {
    display: inline-block;
    text-decoration: none;
    margin-right: 4pt;
    margin-left: 4pt;
    &:hover {
      text-decoration: underline;
    }
  }
}
.quick-summary {
  margin-top: -10pt;
  margin-left: 10pt;
  margin-bottom: 10pt;
  font-size: 10pt;
  & > div {
    display: inline-block;
    padding-right: 15pt;
  }
}

</style>